import * as clientActionCreators from 'store/actionCreators/clients';

import { clientSource } from 'sources';
import { ClientParams } from 'sources/ClientSource';
import { AppThunk } from 'store/store';
import { setError } from 'store/actions/app';

export const list = (params: ClientParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    dispatch(clientActionCreators.setLoading(true));

    const results = await clientSource.List(params);

    dispatch(clientActionCreators.listSuccess(results));
    dispatch(clientActionCreators.setLoading(false));
  } catch (e) {
    dispatch(setError(e?.message));
    dispatch(clientActionCreators.setLoading(false));
  }
};

export const listAll = (params: ClientParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const results = await clientSource.ListAll(params);
    dispatch(clientActionCreators.listAllSuccess(results));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};
